import { render, staticRenderFns } from "./FormModel.vue?vue&type=template&id=34137060&scoped=true&"
import script from "./FormModel.vue?vue&type=script&lang=js&"
export * from "./FormModel.vue?vue&type=script&lang=js&"
import style0 from "./FormModel.vue?vue&type=style&index=0&id=34137060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34137060",
  null
  
)

export default component.exports